import { render, staticRenderFns } from "./leave-detail.vue?vue&type=template&id=7ef01a0b&scoped=true"
import script from "./leave-detail.vue?vue&type=script&lang=js"
export * from "./leave-detail.vue?vue&type=script&lang=js"
import style0 from "./leave-detail.vue?vue&type=style&index=0&id=7ef01a0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef01a0b",
  null
  
)

export default component.exports